/* eslint-disable react/prop-types */
import { SideNav as CarbonSideNav } from '@carbon/react';

export const SideNav = ({ children, ...props }) => (
  <CarbonSideNav {...props}>{children}</CarbonSideNav>
);
